import { render } from "./ProductRow.vue?vue&type=template&id=a42c9c74"
import script from "./ProductRow.vue?vue&type=script&lang=js"
export * from "./ProductRow.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__